import * as contractsSelectors from '@/entity/contracts/model/selectors'
import * as handbookSelectors from '@/entity/handbook/selectors'
import { createSelector } from 'reselect'

export const viewAllOptions = createSelector(
	[handbookSelectors.contractStatuses, handbookSelectors.contractStates],
	(contractStatuses, contractStates) => {
		return { contractStatuses, contractStates }
	}
)

export const contractView = createSelector(
	[
		contractsSelectors.contract,
		handbookSelectors.positionsByKnz,
		handbookSelectors.positions,
		handbookSelectors.workingTimeModes,
		handbookSelectors.regions,
		handbookSelectors.districts,
		handbookSelectors.populatedAreas,
		handbookSelectors.countries,
		handbookSelectors.remoteWorkTypes,
		handbookSelectors.contractTypes,
		handbookSelectors.personalQualities,
		handbookSelectors.professionalSkills,
		handbookSelectors.jobTypes,
		handbookSelectors.socialLeaveTypes,
		handbookSelectors.contractTerms,
		handbookSelectors.workActivityTypes,
		viewAllOptions
	],
	(
		contract,
		positionsByKnz,
		positions,
		workingTimeModes,
		regions,
		districts,
		populatedAreas,
		countries,
		remoteWorkTypes,
		contractTypes,
		personalQualities,
		professionalSkills,
		jobTypes,
		socialLeaveTypes,
		contractTerms,
		workActivityTypes,
		viewAllOptions
	) => {
		const {
			dpositionCode,
			destablishedPostCode,
			dworkingHoursCode,
			dregionCode,
			ddistrictCode,
			dlocalityCode,
			dcountryCode,
			dContractStatus,
			dContractState,
			dremoteWorkCode,
			dContractType,
			skillsList,
			specSkillsList,
			dpartTimeCode,
			district,
			region,
			locality,
			country,
			position,
			socialLeaves,
			dcontractDateCode,
			dharmfulConditionsTypeCode,
		} = contract || {}
		const lang = localStorage.getItem('lang') || 'rus'
		const optionsLang = lang === 'rus' ? 'nameRu' : 'nameKz'
		return {
			...contract,
			dpositionCode: positionsByKnz?.find((item) => item.code === dpositionCode)?.[lang],
			destablishedPostCode: positions?.find((item) => item.id === destablishedPostCode)?.[lang],
			dworkingHoursCode: workingTimeModes?.find((item) => item.code === dworkingHoursCode)?.[lang],
			dregionCode: regions?.find((item) => item.id === dregionCode)?.value,
			ddistrictCode: districts?.find((item) => item.id === ddistrictCode)?.value,
			dlocalityCode: populatedAreas?.find((item) => item.id === dlocalityCode)?.value,
			dcountryCode: countries?.find((item) => item.id === dcountryCode)?.value,
			dContractStatus: viewAllOptions.contractStatuses?.find((item) => item.id === dContractStatus)?.value,
			dContractState: viewAllOptions.contractStates?.find((item) => item.id === dContractState)?.value,
			dremoteWorkCode: remoteWorkTypes?.find((item) => item.code === dremoteWorkCode)?.[lang],
			dContractType: contractTypes?.find((item) => item.id === dContractType)?.value,
			skillsList: personalQualities
				?.filter(({ code }) => skillsList?.includes(code))
				?.map((item) => item[lang]),
			specSkillsList: professionalSkills
				?.filter(({ code }) => specSkillsList?.includes(code))
				?.map((item) => item[lang]),
			skillsListFull: skillsList,
			specSkillsListFull: specSkillsList,
			dpartTimeCode: jobTypes?.find((item) => item.code === dpartTimeCode)?.[lang],
			region: region ? region[optionsLang] : null,
			district: district ? district[optionsLang] : null,
			locality: locality ? locality[optionsLang] : null,
			country: country ? country[optionsLang] : null,
			position: position ? position[optionsLang] : null,
			socialLeaves: socialLeaves?.map((item) => {
				const leaveType = socialLeaveTypes?.find((type) => type.code === item.dleaveTypeCode)
				return {
					...item,
					dleaveTypeCode:
						{
							name: leaveType ? leaveType[lang] : item.dleaveTypeCode,
							value: item.dleaveTypeCode,
						} || item.dleaveTypeCode,
				}
			}),
			dcontractDateCode: contractTerms?.find((item) => item.code === dcontractDateCode)?.[lang],
			harmfulConditions: workActivityTypes?.find((item) => item.code === dharmfulConditionsTypeCode)?.[
				lang
			],
			dharmfulConditionsTypeCode: dharmfulConditionsTypeCode,
		}
	}
)
